import { Select, Input, DatePicker } from 'antd';
import { renderDateTime } from "../../utils";
const { RangePicker } = DatePicker;
export const ThirdPartyBillingBatchColumns = (billingInvoiceNames, customerUidData, userData) => [
    {
        title: '出账批次编号',
        dataIndex: 'name',
        key: 'name',
        search: true,
        renderFormItem: (item, { type, defaultRender, ...rest }) => {
            return (
                <Input
                    style={{
                        width: '100%',
                        textAlign: 'left'
                    }}
                    placeholder="请输入（支持模糊查询）"
                />
            )
        }
    },
    {
        title: '客户ID',
        dataIndex: ['customer', 'uid'],
        key: 'customer',
        search: true,
        renderFormItem: (item, { type, defaultRender, ...rest }) => {
            return (
                <Select
                    style={{
                        width: '100%',
                        textAlign: 'left'
                    }}
                    placeholder="请选择"
                    options={customerUidData?.map((item) => ({
                        label: item.uid,
                        key: item.id,
                        value: item.id
                    }))}
                    allowClear
                    showSearch
                    filterOption={(input, option) =>
                        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                />
            )
        }
    },
    {
        title: '导入批次编号',
        dataIndex: 'billing_invoice_names',
        key: 'billing_invoice_names',
        search: true,
        renderFormItem: (item, { type, defaultRender, ...rest }) => {
            return (
                <Select
                    style={{
                        width: '100%',
                        textAlign: 'left'
                    }}
                    placeholder="请选择"
                    options={billingInvoiceNames?.map((item) => ({
                        label: item.name,
                        key: item.id,
                        value: item.name
                    }))}
                    allowClear
                    showSearch
                    filterOption={(input, option) =>
                        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                />
            )
        }
    },
    {
        title: '物流服务',
        dataIndex: 'logistics_service_names',
        key: 'logistics_service_names',
        search: true,
        renderFormItem: (item, { type, defaultRender, ...rest }) => {
            return (
                <Input
                    style={{
                        width: '100%',
                        textAlign: 'left'
                    }}
                    placeholder="请输入（支持模糊查询）"
                />
            )
        }
    },
    {
        title: '账单状态',
        dataIndex: 'status',
        key: 'status',
        search: true,
        renderFormItem: (item, { type, defaultRender, ...rest }) => {
            return (
                <Select
                    style={{
                        width: '100%',
                        textAlign: 'left'
                    }}
                    placeholder="请选择"
                    allowClear
                    options={[
                        { label: '未下载', value: '0' },
                        { label: '已下载', value: '1' },
                        { label: '确认出账', value: '2' },
                    ]}
                />
            )
        }
    },
    {
        title: '子单号数量',
        dataIndex: 'package_count',
        key: 'package_count',
        search: false,
    },
    {
        title: 'Net Charge Amount',
        dataIndex: 'net_charge_amount',
        key: 'net_charge_amount',
        search: false,
    },
    {
        title: 'Billed Amount',
        dataIndex: 'billed_amount',
        key: 'billed_amount',
        search: false,
    },
    {
        title: 'Actual Billed Amount',
        dataIndex: 'actual_billed_amount',
        key: 'actual_billed_amount',
        search: false,
    },
    {
        title: 'Actual Billed Date',
        dataIndex: 'actual_billed_date',
        key: 'actual_billed_date',
        search: false,
    },
    {
        title: '账单负责人',
        dataIndex: ['user', 'username'],
        key: 'user',
        search: true,
        renderFormItem: (item, { type, defaultRender, ...rest }) => {
            return (
                <Select
                    style={{
                        width: '100%',
                        textAlign: 'left'
                    }}
                    placeholder="请选择"
                    options={userData?.map((item) => ({
                        label: item.username,
                        key: item.id,
                        value: item.id
                    }))}
                    allowClear
                    showSearch
                    filterOption={(input, option) =>
                        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                />
            )
        }
    },
    {
        title: '完成出账时间',
        dataIndex: 'bill_time',
        key: 'bill_time',
        render: renderDateTime,
        search: true,
        renderFormItem: (item, { type, defaultRender, ...rest }) => {
            return <RangePicker />
        },
    }
]